import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  
  // Show simplified footer for non-homepage app pages
  const isHomePage = location.pathname === '/';
  const isSimpleFooter = !isHomePage;

  if (isSimpleFooter) {
    return (
      <footer className="footer footer-simple">
        <div className="footer-container">
          <div className="footer-simple-content">
            <p>&copy; {currentYear} The Interconnector. All rights reserved.</p>
            <div className="footer-simple-links">
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/admin" style={{ opacity: 0.4, fontSize: '0.75rem' }}>Admin</Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-brand">
            <h3>The Interconnector</h3>
            <p>Connecting communities, building relationships.</p>
          </div>
        </div>

        <div className="footer-section">
          <h4>Company</h4>
          <ul className="footer-links">
            <li><Link to="/about">About Us</Link></li>
            <li><span className="footer-link-inactive">How It Works</span></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><span className="footer-link-inactive">Careers</span></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Support</h4>
          <ul className="footer-links">
            <li><span className="footer-link-inactive">Help Center</span></li>
            <li><span className="footer-link-inactive">FAQ</span></li>
            <li><span className="footer-link-inactive">Community Guidelines</span></li>
            <li><Link to="/safety">Safety</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <ul className="footer-links">
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><span className="footer-link-inactive">Cookie Policy</span></li>
            <li><span className="footer-link-inactive">Age Verification</span></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect</h4>
          <ul className="footer-links">
            <li><a href="mailto:james@theinterconnector.com">Email Us</a></li>
            <li><span className="footer-link-inactive">Twitter</span></li>
            <li><span className="footer-link-inactive">Instagram</span></li>
            <li><span className="footer-link-inactive">LinkedIn</span></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} The Interconnector. All rights reserved.</p>
            <div className="footer-badges">
              <span className="footer-badge">🇬🇧 Made in the UK</span>
              <span className="footer-badge">🔒 Secure & Private</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;